export const dateFormat = 'DD.MM.YYYY';
